import React, {Component} from 'react'
import { Link } from 'react-router-dom';
import ImageGallery from 'react-image-gallery';

class FavoriteBanner extends Component {

    render() {
        const estate = this.props.estate;
        let images = estate.images ? estate.images.image.map(i => {
            return {
                original: i._cdata,
                thumbnail: i._cdata,
            }
        }) : [];

        let prix = 0;

        if (estate.prix) {
            prix = parseInt(estate.prix._text).toLocaleString(
                undefined, // leave undefined to use the browser's locale,
                            // or use a string like 'en-US' to override it.
                { minimumFractionDigits: 0 }
            );
        }

        return (
            <div className="favorite-banner property">
                <div className="overlay property-content col-md-5 col-xs-11">
                    <div className="property-price">
                        <h3><span>{prix}€</span></h3>
                        {estate.type_offre ?
                            estate.type_offre._cdata === 'Location' ?
                                <h5>
                                    Par Mois
                                </h5>
                            : ""
                        : ""}
                    </div>
                    <div className="title">
                        <Link   className="propertyTitleLink"
                                style={{color: window.customColor}}
                                to={`/estate/${estate.id._text}`}>{estate.titre ? estate.titre._cdata.trim() : "-"}</Link>
                    </div>
                    <div className="property-location">
                        {estate.ville ? (estate.ville._attributes.humanName ? estate.ville._attributes.humanName : this.capitalizeFirstLetter(estate.ville._cdata)) : "-"}
                    </div>
                    <div className="property-props">
                        {estate.chambres ? <span>Chambres: {estate.chambres._text} </span> : ''}
                        {estate.wc ? <span>Baignoire: {estate.wc._text} </span> : ''}
                        {estate.surface_habitable ? <span>m<sup>2</sup>: {estate.surface_habitable._cdata} </span> : ''}
                    </div>
                    <div className="property-offre">
                        {estate.type_offre ? estate.type_offre._cdata : ""}
                    </div>
                    <Link to={`/estate/${estate.id._text}`}>
                        <button     className="button-theme property-details"
                                    style={{background: window.customColor, borderColor: window.customColor}}>
                                    Détails <i className="fa fa-angle-right"></i>
                        </button>
                    </Link>
                </div>
                <ImageGallery
                    items={images}
                    showThumbnails={false}
                    showFullscreenButton={false}
                    showPlayButton={false}
                    showNav={false}
                />
            </div>
        )
    }
}
export default FavoriteBanner;

// autoPlay={true}
